<template>
  <div>
    <SideBar :bar_name="tabName" :user="user"></SideBar>
    <v-main>
      <v-container>
        <AgentBranchComp v-bind="{ user, tabName }" />
      </v-container>
    </v-main>
  </div>
</template>

<script>
import SideBar from "@/components/SideBar";
import AgentBranchComp from "@/components/ChangFamily/Agents/AgentBranch";

export default {
  name: "AgentBranch",
  components: {
    SideBar,
    AgentBranchComp,
  },
  data() {
    return {
      user: this.$user,
      tabName: "Agent Branch User Management",
    };
  },
};
</script>
